if (!customElements.get('slideshow-component-v2')) {
  class SlideshowComponentV2 extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {

      this.autoplay = this.dataset.autoplay; //True or False
      this.speed = this.dataset.speed; //Speed in ms
      this.swiperContainer = this.querySelector('.swiper');

      if (this.swiperContainer && Swiper) {
        this.swiper = new Swiper(this.swiperContainer, {
          slidesPerView: 1,
          loop: true,
          autoHeight: true,
          navigation: {
            nextEl: this.querySelector(".swiper-button-next"),
            prevEl: this.querySelector(".swiper-button-prev"),
          },
          autoplay: this.autoplay === 'true' ? { delay: this.speed } : false
        });
      }
    }

    disconnectedCallback() {
    }
  }

  customElements.define('slideshow-component-v2', SlideshowComponentV2);
}